import { render, staticRenderFns } from "./CustomerComplaintTab.vue?vue&type=template&id=481eae46"
import script from "./CustomerComplaintTab.vue?vue&type=script&lang=js"
export * from "./CustomerComplaintTab.vue?vue&type=script&lang=js"
import style0 from "./CustomerComplaintTab.vue?vue&type=style&index=0&id=481eae46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports